/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChargeInstapayToken } from '../models/ChargeInstapayToken';
import type { CreditCardTypeEnum } from '../models/CreditCardTypeEnum';
import type { InstapayUrlForm } from '../models/InstapayUrlForm';
import type { PaymentTypeEnum } from '../models/PaymentTypeEnum';
import type { TransactionDetails } from '../models/TransactionDetails';
import { request as __request } from '../core/request';

export class InstaPayVService {

    /**
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static async instaPayVGetUrl(
        requestBody?: InstapayUrlForm,
    ): Promise<string> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/instapay/url`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns TransactionDetails Created
     * @throws ApiError
     */
    public static async instaPayVMakePayment(
        requestBody?: ChargeInstapayToken,
    ): Promise<TransactionDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/instapay/charge`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param paymentType
     * @param amount
     * @param ccType
     * @returns number OK
     * @throws ApiError
     */
    public static async instaPayVGetServiceFee(
        billingAccountId: string,
        paymentType: PaymentTypeEnum,
        amount: number,
        ccType?: CreditCardTypeEnum,
    ): Promise<number> {
        const result = await __request({
            method: 'GET',
            path: `/api/v3/instapay/service-fee`,
            query: {
                'BillingAccountId': billingAccountId,
                'PaymentType': paymentType,
                'Amount': amount,
                'CCType': ccType,
            },
        });
        return result.body;
    }

}